/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TopupInputs */

const cs_enum_topup = /** @type {(inputs: Enum_TopupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobití`)
};

const en_enum_topup = /** @type {(inputs: Enum_TopupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top up`)
};

/**
* | output |
* | --- |
* | "Top up" |
*
* @param {Enum_TopupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_topup = /** @type {((inputs?: Enum_TopupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TopupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_topup(inputs)
	return cs_enum_topup(inputs)
});